import type { ErrorsOf } from '@ds/components/Form'

export const focusFirstErrorFormField = (errors: ErrorsOf<Array<string>>) => {
  const errorKeys = Object.keys(errors)

  const erroringElements = errorKeys.map((key) => document.getElementById(key))

  // Sort the elements based on their position in the DOM
  const sortedElements = erroringElements.sort((a, b) => {
    if (
      b &&
      a?.compareDocumentPosition(b) === Node.DOCUMENT_POSITION_PRECEDING
    ) {
      return 1
    }

    return -1
  })

  sortedElements[0]?.focus()
}
